<div class="calculate-question" *ngIf="showQuestion">
    <h4 *ngIf="showQuestionName">
        {{ getText(question.globalizationConfig, "title") }}
    </h4>
    <div class="calculate-value" *ngIf="!isNaN(value)">
        <span *ngIf="showCalculateLabel" [ngStyle]="{ color: color }">{{ valueLabel }}</span>
        <div style="display: flex; align-items: center">
            <h4 [ngStyle]="{ color: color }">{{ (formGroup.controls["field" + question.order]?.value | toFixed: 1) || "0" }}</h4>
            <p *ngIf="showCalculateLabel" style="margin-left: 10px">{{ "calculate.totalOf" | translate }} {{ maxValue | toFixed: 1 }}</p>
        </div>
    </div>
    <h4 *ngIf="isNaN(value)" [ngStyle]="{ color: 'var(--ion-color-danger)' }">
        {{ "calculate.noRelatedGrades" | translate }}
    </h4>
</div>
